import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {ProfileRoutingModule} from './profile-routing.module';
import {EditUserComponent} from './edit-user/edit-user.component';
import {EditCompanyComponent} from './edit-company/edit-company.component';

import {ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from './profile.component';
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';

/**
 * @class ProfileModule
 * @memberOf RoutesRoutingModule
 * @description This is a module which included all the components of reservation section. It has been used in RoutesRoutingModule
 */
const COMPONENTS = [
    EditCompanyComponent,
    EditUserComponent,
    ProfileComponent
];

const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, ProfileRoutingModule, ReactiveFormsModule, MatCardModule, MatGridListModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC],
    entryComponents: COMPONENTS_DYNAMIC,
})

export class ProfileModule {
}
